import React from 'react';
import PropTypes from 'prop-types';
import SimpleButton from '@components/SimpleButton';

function ActionLine({ text, onClick }) {
  return <SimpleButton label={text} size="small" onClick={onClick} />;
}

ActionLine.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

export default ActionLine;
